import { render, staticRenderFns } from "./Study-detail.vue?vue&type=template&id=bf1336e6&scoped=true&"
import script from "./Study-detail.vue?vue&type=script&lang=js&"
export * from "./Study-detail.vue?vue&type=script&lang=js&"
import style0 from "./Study-detail.vue?vue&type=style&index=0&id=bf1336e6&prod&lang=css&"
import style1 from "./Study-detail.vue?vue&type=style&index=1&id=bf1336e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1336e6",
  null
  
)

export default component.exports